export default "__VITE_ASSET__BqqGVRqS__"